var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniputi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_1285_1268)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1285_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7448 7.69653C32.7448 8.57669 33.6143 9.891 34.4945 10.9942C35.6261 12.4176 36.9784 13.6596 38.5287 14.6073C39.6912 15.3179 41.1004 15.9999 42.2344 15.9999M42.2344 15.9999C41.1004 15.9999 39.69 16.682 38.5287 17.3925C36.9784 18.3415 35.6261 19.5834 34.4945 21.0045C33.6143 22.1089 32.7448 23.4255 32.7448 24.3033M42.2344 15.9999H13.7656",
    stroke: "white",
    strokeWidth: 2.3724
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1285_1268",
    x1: 0,
    y1: 16,
    x2: 56,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F466C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1285_1268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4688,
    height: 28.4688,
    fill: "white",
    transform: "translate(13.7656 1.76562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniputi);
export default __webpack_public_path__ + "static/media/miniputi.d49432a820765304227e08e46ab2ebab.svg";
export { ForwardRef as ReactComponent };